<template>
  <main class="main main--auth main--login">
    <div class="gradient-bg" />

    <ui-auth
      slug="login"
      submit="Sign In"
    />
  </main>
</template>

<script>
// Models
import meta from 'models/meta';

// Services
import { createMeta } from 'services/meta';

// Ui
import UiAuth from 'ui/Auth';


// Export
export default {
  name: `view-login`,

  // Meta data
  metaInfo: {
    title: meta.login.title,
    meta: createMeta(meta.login.meta),
  },

  // Components
  components: {
    UiAuth,
  },
};
</script>



// WEBPACK FOOTER //
// Login.vue?67894757